<template>
    <div>
        <b-row class="align-items-center mt-3 mb-3">
            <b-col cols="12" :md="tab === 'email' ? '6' : '10'">
                <SearchComponent v-model="filters.search" :disabled="loading" />
            </b-col>
            <b-col cols="12" :md="tab === 'email' ? '6' : '2'" class="mb-2">
                <div class="mt-3 mt-md-2">
                    <router-link :to="{ name: 'back.comunicados.crear', query: { tipo: tab === 'email' ? 1 : 2 } }" :class="{ 'disabled': loading }" class="btn btn-primary mr-2">
                        CREAR COMUNICADO
                    </router-link>
                    <slot name="extra-buttons"></slot>
                </div>
            </b-col>
        </b-row>
        <div class="text-center p-5" v-if="loading">
            <div class="spinner-border text-primary" role="status ">
                <span class="sr-only">Cargando...</span>
            </div>
        </div>
        <div class="table" style="overflow-x: hidden !important;" v-else>
            <b-table hover :items="comunicados.data" :busy="loading" :fields="fields" show-empty>
                <template #empty>
                    <h5 class="text-center mt-3">No hay comunicados creados.</h5>
                </template>

                <template #cell(titulo)="{ item }">
                    <template v-if="tab === 'email'">
                        {{ item.titulo }}
                    </template>
                    <template v-else>
                        <b-tooltip 
                            :target="'whatsapp-template-' +  item.id" 
                            placement="left"
                        >
                            <VistaPreviaComponent :components="item.whatsappTemplate?.components" />
                        </b-tooltip>
                        <span :id="'whatsapp-template-' + item.id">
                            {{ item.whatsappTemplate?.name }}
                        </span>
                    </template>
                </template>

                <template #cell(listo_para_enviar)="data">
                    <CheckOrCross :condition="data.value"/>
                </template>

                <template #cell(enviado)="data">
                    <CheckOrCross :condition="data.value"/>
                </template>

                <template #cell(coste_envio_whatsapp)="{ item }">
                    {{ item.coste_envio_whatsapp | formatear_precio }} <InfoToolTip :info="'Coste del envio por cada mensaje: ' + coste_envio_whatsapp_marketing"/>
                </template>

                <template #cell(id)="data">
                    <OpcionesDropdownTableComponent 
                        :lastIndex="comunicados.data?.length > 3 && data.index >= comunicados.data?.length - 3"
                        v-bind:options="[
                            { to: { name: 'back.comunicados.editar', params: { comunicado_id: data.value}}, label: 'Editar'},
                            ...data.item.tipo === 2 ? [{ to: { name: 'back.comunicados.usuarios', params: { comunicado_id: data.value }}, label: 'Usuarios'}] : [],
                            ...data.item.tipo === 2 && !data.item.listo_para_enviar ? [{ type: 'action', action: () => showModal('validar-' + data.value), label: 'Validar' }] : [],
                            ...data.item.tipo === 1 ? [{ to: { name: 'back.comunicados.estadisticas', params: { comunicado_id: data.value}}, label: 'Estadísticas emails'}] : [],
                            ...data.item.listo_para_enviar ? [ { type: 'action', action:() => showModal('comunicado-' + data.value), label: 'Enviar'}] : [],
                            { type: 'action', action:() => showModal('prueba-' + data.value), label: 'Enviar prueba'},
                            { type: 'action', action:() => showModal('borrar-' + data.value), label: 'Borrar'},
                        ]"
                    />
                    <ModalComponent
                        :name="'validar-' + data.item.id"
                        title="Validar usuarios del comunicado"
                        @close="closeModal('validar-' + data.item.id, false)"
                    >
                        <h5 class="mb-3">
                            {{ Object.keys(errors).length === 0 ? '¿Estás seguro de validar todos los usuarios de este comunicado?' : 'Algunos de los usuarios del comunicado continen los siguientes errores:' }}
                        </h5>

                        <div v-if="errors.mensajes?.length">
                            <b-col cols="12" class="alert alert-danger">
                                <strong>Mensajes de error:</strong>
                                <ul class="text-left mt-2">
                                    <li v-for="(error, index) in errors.mensajes" :key="index">
                                        {{ error }}
                                    </li>
                                </ul>
                            </b-col>
                        </div>

                        <div v-if="errors.telefonos_repetidos?.length">
                            <b-col cols="12" class="alert alert-warning">
                                <strong>Teléfonos repetidos:</strong>
                                <ul class="text-left mt-2">
                                    <li v-for="(telefono, index) in errors.telefonos_repetidos" :key="'tel-' + index">
                                        {{ telefono }}
                                    </li>
                                </ul>
                            </b-col>
                        </div>

                        <button class="btn btn-primary" type="button" @click="validar(data.item.id)" :disabled="loading || Object.keys(errors).length > 0">VALIDAR</button>
                    </ModalComponent>
                    <BorrarModal :comunicado="data.item" v-on:close="closeModal"></BorrarModal>
                    <EnviarPrueba :comunicado="data.item" v-on:close="closeModal"></EnviarPrueba>
                    <EnviarComunicado :comunicado="data.item" :events="events" :bases="bases" :recordatorios="recordatorios.data" v-on:close="closeModal"></EnviarComunicado>
                </template>
            </b-table>
            <b-row class="align-items-center justify-content-between">
                <b-col cols="12" md="2" class="ml-0 pl-0">
                    <ElementosPorPaginaComponent v-model="filters.per_page" />
                </b-col>
                <b-col cols="12" md="2">
                    <b-pagination 
                        v-model="filters.page"
                        :total-rows="comunicados.meta.total"
                        :per-page="filters.per_page"
                        first-number
                        last-number
                        class="ml-2 pl-1"
                        @input="debouncedGetComunicados"
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import BorrarModal from '@/views/backend/comunicados/modals/Delete';
import EnviarPrueba from '@/views/backend/comunicados/modals/EnviarPrueba';
import EnviarComunicado from '@/views/backend/comunicados/modals/EnviarComunicado';
import CheckOrCross from "@/components/backend/components/CheckOrCross";
import ModalComponent from "@/components/backend/components/ModalComponent";
import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
import VistaPreviaComponent from '@/components/backend/plantillas-whatsapp/VistaPreviaComponent';
import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent';
import SearchComponent from '@/components/backend/components/SearchComponent.vue';
import InfoToolTip from '../../common/InfoToolTip.vue';

export default {
    props: { tab: String },
    data() {
        return {
            comunicados: { meta: { current_page: 1 } },
            loading: false,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                tipo: this.$route.query.tipo ?? 1
            },
            events: [],
            bases: [],
            recordatorios: [],
            errors: {}
        }
    },
    created() {
        this.getComunicados();
        this.getEvents();
        this.getBases();
        this.debouncedGetComunicados = _.debounce(this.getComunicados, 500)
    },
    methods: {
        borrar(id) {
            this.setLoading(true);

            const params = {
                filters : {},
                comunicado_id: id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.getComunicados();
            }).finally(() => this.setLoading(false));
        },
        getComunicados : function() {
            this.setLoading(true);
            this.filters.tipo = this.tab === 'email' ? 1 : 2;

            const params = {
                filters : this.filters
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.index'), params).then(res => {
                this.comunicados = res.data;
            }).finally(() => this.setLoading(false));
        },
        validar(comunicado_id) {
            this.setLoading(true);

            const params = {
                filters : {},
                comunicado_id: comunicado_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.users.validar'), params).then(res => {
                this.$toast.success(res.data?.message);
                this.getComunicados();
            }).catch(error => {
                if (error.response.data) {
                    this.$set(this.errors, 'mensajes', error.response.data.errors);
                    this.$set(this.errors, 'telefonos_repetidos', error.response.data.telefonos_repetidos);
                }
            }).finally(() => this.setLoading(false));
        },
        setPage(page) {
            this.filters.page = page;
            this.getComunicados();
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, borrado) {
            this.$modal.hide(modal);
            this.errors = {};
            
            if(borrado) {
                this.getComunicados();
            }
        },
        getEvents : function() {
            this.setLoading(true);

            const data = {
                filters: {
                    to_select: true,
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.events = res.data;
            }).finally(() => this.setLoading(false));
        },
        getBases : function() {
            this.setLoading(true);

            const params = {
                filters: {
                    per_page: 100,
                    page: 1,
                    search: ''
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.index'), params).then(res => {
                this.bases = res.data.data;
            }).finally(() => this.setLoading(false));
        },
        setLoading(estado) {
            this.loading = estado;
            this.$emit('setLoading', estado);
        }
    },
    watch: {
        'filters.search'() {
            this.debouncedGetComunicados();
        },
        'filters.page'() {
            this.debouncedGetComunicados();
        },
        'filters.per_page'() {
            this.debouncedGetComunicados();
        }
    },
    computed: {
        fields() {
            let fields = [
                { key: 'titulo', label: 'título' },
                'asunto',
                { key: 'fecha_envio', label: 'Fecha de envio' },
                { key: 'listo_para_enviar', label: 'Listo para enviar', class: 'text-center' },
                { key: 'enviado', class: 'text-center' },
                { key: 'id', label: 'opciones', class: 'text-center' }
            ];

            if (parseInt(this.$route.query.tipo) === 2) {
                const index = fields.findIndex(field => field.key === 'id');

                if (index !== -1) {
                    fields.splice(index, 0, { key: 'coste_envio_whatsapp', label: 'Coste de envío WhatsApp', class: 'text-center' });
                }
            }

            return fields;
        },
        coste_envio_whatsapp_marketing() {
            return this.$n(this.$store.getters.getTeatro.coste_envio_whatsapp_marketing, 'currency');
        }
    },
    components: {
        OpcionesDropdownTableComponent, VistaPreviaComponent, ElementosPorPaginaComponent,
        CheckOrCross, ModalComponent, BorrarModal, EnviarPrueba, EnviarComunicado, SearchComponent, InfoToolTip
    }
}
</script>
<style>
.tooltip-inner {
    max-width: 800px !important;
}

@media (max-width: 768px) {
    .tooltip-inner {
        max-width: 320px !important;
    }

    .bs-tooltip-right {
        left: 91px !important;
    }
    
    .tooltip.b-tooltip {
        opacity: 1;
    }
}

.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>